
<div
  :class="
    classes(
      n('item'),
      [isActive, n('item--active')],
      [props.disabled, n('item--disabled')],
    )
  "
  :data-index="props.index"
  :style="itemStyle"
  @click="handleClick"
>
  <!-- 图标插槽 -->
  <div
    v-if="showIcon"
    :class="n('item-icon')"
  >
    <slot
      name="icon"
      :active="isActive"
      :disabled="props.disabled"
    >
      <component
        :is="currentIcon"
        v-if="currentIcon"
      />
    </slot>
  </div>

  <!-- 标题插槽 -->
  <div :class="n('item-title')">
    <slot
      name="title"
      :active="isActive"
      :disabled="props.disabled"
    >
      <slot>{{ props.title }}</slot>
    </slot>
  </div>
</div>
